var _g, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _path6, _circle, _circle2, _circle3, _path7, _path8, _circle4, _circle5, _circle6, _path9, _path10, _path11, _path12, _path13, _rect5, _rect6, _rect7, _rect8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonitorsDisplays(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 126,
    viewBox: "0 0 199 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_2_32232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.5 111.778H14L27.0858 95.2285H171.414L184.5 111.778Z",
    fill: "#1D1F45"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.051 8.35841C23.1544 4.01556 26.7047 0.548828 31.0488 0.548828H170.145C174.489 0.548828 178.04 4.01555 178.143 8.35841L180.071 89.3471C180.178 93.8387 176.566 97.5375 172.074 97.5375H29.1205C24.6277 97.5375 21.0158 93.8387 21.1227 89.3471L23.051 8.35841Z",
    fill: "#313345"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0488 1.54883H170.145C173.946 1.54883 177.053 4.58221 177.143 8.38221L179.072 89.3709C179.165 93.301 176.005 96.5375 172.074 96.5375H29.1205C25.1893 96.5375 22.0289 93.301 22.1225 89.3709L24.0508 8.38222C24.1412 4.58222 27.2477 1.54883 31.0488 1.54883Z",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M30.1646 88.3009L32.0392 14.8142C32.0669 13.7299 32.9539 12.8652 34.0386 12.8652H166.385C167.47 12.8652 168.357 13.7299 168.385 14.8142L170.259 88.3009H30.1646Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.383 32.8781V22.1016H166.41L166.795 32.8781H126.383Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 129.462,
    y: 25.1807,
    width: 18.474,
    height: 1.5395,
    rx: 0.769752,
    fill: "#DADADA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 129.462,
    y: 28.2598,
    width: 10.0068,
    height: 1.5395,
    rx: 0.769752,
    fill: "#DADADA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 141.009,
    y: 28.2598,
    width: 5.38826,
    height: 1.5395,
    rx: 0.769752,
    fill: "#DADADA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 147.937,
    y: 28.2598,
    width: 12.316,
    height: 1.5395,
    rx: 0.769752,
    fill: "#DADADA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.383 45.964V35.1875H166.41L166.795 45.964H126.383Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.0054 17.4837L32.0538 14.8288C32.0736 13.7386 32.9631 12.8652 34.0534 12.8652H166.405C167.482 12.8652 168.366 13.7181 168.404 14.7944L168.499 17.4837H32.0054Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.1711,
    cy: 15.174,
    r: 0.769752,
    fill: "#8BEF75"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.862,
    cy: 15.174,
    r: 0.769752,
    fill: "#FFD27A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5534,
    cy: 15.174,
    r: 0.769752,
    fill: "#FF7171"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.8555 8.24698L27.8555 7.16785C27.8556 6.06333 28.751 5.16797 29.8555 5.16797H170.984C172.077 5.16797 172.967 6.04505 172.984 7.13769L173 8.24698H27.8555Z",
    fill: "#E2E8ED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M179.772 76.7539L180.071 89.3468C180.178 93.8383 176.566 97.5372 172.074 97.5372H29.1205C24.6277 97.5372 21.0158 93.8383 21.1227 89.3468L21.4226 76.7539",
    stroke: "#2B2D43"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5534,
    cy: 6.70725,
    r: 0.769752,
    fill: "#716E95"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.2434,
    cy: 6.70725,
    r: 0.769752,
    fill: "#716E95"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9343,
    cy: 6.70725,
    r: 0.769752,
    fill: "#716E95"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M39.365 23.0636C39.3854 22.5265 39.8268 22.1016 40.3643 22.1016H123.087C123.634 22.1016 124.08 22.5416 124.087 23.0889L124.831 81.8993C124.838 82.4565 124.388 82.9119 123.831 82.9119H38.131C37.5638 82.9119 37.1102 82.4408 37.1317 81.874L39.365 23.0636Z",
    fill: "#00A3C9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6296 100.836C79.1164 99.7648 80.1843 99.0771 81.3607 99.0771H119.834C121.01 99.0771 122.078 99.7648 122.565 100.836L126.892 110.356C128.096 113.005 126.16 116.012 123.251 116.012H77.9435C75.0343 116.012 73.0982 113.005 74.302 110.356L78.6296 100.836Z",
    fill: "url(#paint0_linear_2_32232)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8242 97.5381H105.601V106.005C101.67 107.403 99.3265 107.383 94.8242 106.005V97.5381Z",
    fill: "url(#paint1_linear_2_32232)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75.9648 114.857H124.844",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.9476 49.8131L39.4014 66.3628H123.304V30.5693L101.366 55.2014L81.7377 38.6517L61.3393 55.2014L50.9476 49.8131Z",
    fill: "url(#paint2_linear_2_32232)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 129.462,
    y: 38.2666,
    width: 18.474,
    height: 1.5395,
    rx: 0.769752,
    fill: "#DADADA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 129.462,
    y: 41.3457,
    width: 10.0068,
    height: 1.5395,
    rx: 0.769752,
    fill: "#DADADA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 141.009,
    y: 41.3457,
    width: 5.38826,
    height: 1.5395,
    rx: 0.769752,
    fill: "#DADADA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 147.937,
    y: 41.3457,
    width: 12.316,
    height: 1.5395,
    rx: 0.769752,
    fill: "#DADADA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2_32232",
    x: 0,
    y: 81.2285,
    width: 198.5,
    height: 44.5498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_2_32232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_32232",
    x1: 100.597,
    y1: 99.0771,
    x2: 100.597,
    y2: 116.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1E31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_32232",
    x1: 94.8242,
    y1: 99.0776,
    x2: 106.755,
    y2: 99.0776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526096,
    stopColor: "#575A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323448"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_32232",
    x1: 81.3528,
    y1: 30.5693,
    x2: 81.3528,
    y2: 66.3628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#577C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#577C85",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorsDisplays);
export default __webpack_public_path__ + "static/media/MonitorsDisplays.b8aeaab5882b0828e64331632058fb37.svg";
export { ForwardRef as ReactComponent };